import { RemoteImportSpreadsheet } from '../../../data/usecases/import-spreadsheet/import-spreadsheet'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory-no-redirect'

export const makeImport = ():any => new RemoteImportSpreadsheet('/importacao/vendas', makeAxiosHttpClient())

export const makeSales = ():any => new RemoteImportSpreadsheet('/vendaitemauxiliar', makeAxiosHttpClient())
